export function processImages(array) {
  var dictionary = {}

  array.forEach(({ node }) => {
    dictionary[node.directus_id] = node
  })

  return dictionary
}
